module.exports = "/assets/data/6a89f7c3958406d86a875945d09749cb-E1.data.json";